<template>
  <div>
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg)"></div>
    <!-- /.background-image-search -->

    <base-header class="pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <b-col xs="12" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block py-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col xs="12" lg="6" align="right">
          <router-link to="/collection/add-collection"><base-button type="secondary" size="sm" class="btn-secondary--alt">Add Collection</base-button></router-link>
        </b-col>
      </b-row>
    </base-header>

    <CollectionList :searchUri="'collections/getMyCollections'" :binder="this.$store.state.collections.myCollections" :payload="{ 'userId': this.$store.state.authentication.user.user.id }" />

  </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CollectionList from '@/views/Collections/CollectionList.vue';

export default {
  components: {
    RouteBreadCrumb,
    CollectionList
  }
};
</script>
<style>
</style>
